import { type MutableRefObject, useMemo } from 'react';

import { DisplayConfigContext } from './context/display-config.context.js';
import { HiveDisplay } from './displays/HiveDisplay.js';
import { canvasContainer } from './HiveCanvasLayout.sty.js';
import { Canvas } from '../../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../../core/components/canvas/CanvasContext.js';
import { CanvasShape } from '../../../core/components/canvas/types/canvas-shape.js';
import { useGraphSize } from '../../../core/components/chart-layout/hooks/useGraphSize.js';
import { useHoneycombLabelsDisplay } from '../../hooks/use-honeycomb-labels-display.js';
import { useHoneycombSelectionState } from '../../store/selectors.js';

export const HiveCanvasLayout = () => {
  const graphSize = useGraphSize();
  const { width, height } = graphSize;
  const { hovered } = useHoneycombSelectionState();
  const labelsDisplay = useHoneycombLabelsDisplay();
  const displayConfig = useMemo(
    () => ({ hovered, labelsDisplay }),
    [hovered, labelsDisplay],
  );

  return (
    <DisplayConfigContext.Provider value={displayConfig}>
      <div className={canvasContainer}>
        <CanvasContext.Provider
          value={{
            shapeRefs: new Map<string, MutableRefObject<CanvasShape>>(),
          }}
        >
          <Canvas width={width} height={height}>
            <HiveDisplay />
          </Canvas>
        </CanvasContext.Provider>
      </div>
    </DisplayConfigContext.Provider>
  );
};

HiveCanvasLayout['displayName'] = 'HiveCanvasLayout';
